(function($, undefined) {

	'use strict';
    var addSlideBtn;
    var addSlideBox;
    var addSlideEventBtn;
    var addSlideEventBox;
    var sliderListElements;
    var deleteSlideBtn;
    var deleteSlideBtnConfirm;
    var toggleActiveBtn;
    var saveSlideBtn;
    var chooseEventBtn;
    
    var togglePanelImg = function(){
        var t = $(this);
        if (t.hasClass("logged-nav-item-active")) {
            t.removeClass("logged-nav-item-active");
            addSlideBox.slideUp();
        }
        else {
            t.addClass("logged-nav-item-active");
            addSlideEventBox.slideUp();
            addSlideEventBtn.removeClass("logged-nav-item-active");            
            addSlideBox.slideDown();
        }
    };
    
    
    var togglePanelEventSlide = function(){
        var t = $(this);
        if (t.hasClass("logged-nav-item-active")) {
            t.removeClass("logged-nav-item-active");
            addSlideEventBox.slideUp();
        }
        else {
            t.addClass("logged-nav-item-active");
            addSlideBox.slideUp();
            addSlideBtn.removeClass("logged-nav-item-active");
            addSlideEventBox.slideDown();
        }
    };
    
    var initSort = function(){
        $(".slider-list-ctn").sortable({
            handle: ".handle",
            revert: 160,
            tolerance: "pointer",
            scrollSensitivity: 60,
            scrollSpeed: 30,
            update: function(e, ui) {
                var index = ui.item.index();
                var id = $(ui.item).attr("data-id");
                
                var url = "/action/manageSlide";          
                
                var data = new FormData();
                data.append("id", id);
                data.append("targetPosition", index);
                data.append("ajax", "true");
                
                $.ajax({
                    url: url,
                    data: data,
                    cache: false,
                    contentType: false,
                    processData: false,
                    type: 'POST',
                    success: function(response) {
                    }
                });
            }
        });        
    };
    
    var slideId;
    var line;
    var deleteSlideConfirm = function(){
        var t = $(this);
        line = t.closest(".slider-list-elmt");
        slideId = t.attr("data-slideId");
    };
    
    var deleteSlide = function(){        
        var url = "/action/manageSlide";

        var data = new FormData();
        data.append("id", slideId);
        data.append("delete", "true");
        data.append("ajax", "true");

        $.ajax({
            url: url,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function(response) {
                line.slideUp();
            }
        });
    };
    
    var toggleActive = function(){
        var t = $(this);
        var active = t.hasClass("active");
        var id = t.attr("data-slideId");
        var url = "/action/manageSlide";

        var data = new FormData();
        data.append("id", id);
        data.append("active", !active);
        data.append("action", "true");
        data.append("ajax", "true");

        $.ajax({
            url: url,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function(response) {
                if(active){
                    t.removeClass("active");
                }
                else{
                    t.addClass("active");                    
                }                    
            }
        });
    };
    
    var saveSlide = function(){
        var form = $(this).closest(".add-slide-form");
        formValidator.validateForm(form);
        
        saveSlideBtn.addClass("disabled");
        if (!form.hasClass('has-error')) {
            form.submit();
        }
        else{            
            saveSlideBtn.removeClass("disabled");
        }
    };
    
	var init = function () {
        addSlideBox = $('.create-slider-image-box');
        addSlideBtn = $('.create-new-image-btn');
        addSlideBtn.on("click", togglePanelImg);
        
        addSlideEventBox = $('.create-slider-event-box');
        addSlideEventBtn = $('.create-slide-event-btn');
        addSlideEventBtn.on("click", togglePanelEventSlide);
        
        sliderListElements = $(".slider-list-elmt");
        if(sliderListElements.length !== 0){
            initSort();
        }
        
        saveSlideBtn = $(".save-slide-btn");
        saveSlideBtn.on("click", saveSlide);
        
        deleteSlideBtn = $(".slide-delete");
        deleteSlideBtn.on("click", deleteSlideConfirm);
        
        deleteSlideBtnConfirm = $(".delete-slide-btn");
        deleteSlideBtnConfirm.on("click", deleteSlide);        
        
        toggleActiveBtn = $(".slide-power");
        toggleActiveBtn.on("click", toggleActive);
        
	};

	var slider = Fw.component.export('slider', {
		init: init
	});

})(jQuery);